module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  computed:

    visible: ->
      @.$store.state.cookie.cookies['kgm-cookie-accept-hidden'] != true

  methods:

    onClickOk: ->
      @.$store.dispatch('cookie/set', { module: 'cookie-accept', name: 'hidden', value: true })

    loadFromCookie: ->
      @.$store.dispatch('cookie/load', { module: 'cookie-accept', name: 'hidden' })

  created: ->
    @loadFromCookie()


// WEBPACK FOOTER //
// ./assets/js/frontend/components/cookie_accept/index.coffee